var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5766 10.4475C10.5766 9.44835 11.3298 8.63251 12.2627 8.61418C12.16 6.85418 11.1158 5.36001 9.66929 4.70001C9.51523 5.54335 8.82194 6.16668 7.99171 6.16668C7.16147 6.16668 6.46818 5.53418 6.31412 4.70001C4.86763 5.36001 3.83197 6.85418 3.7207 8.61418C4.66221 8.62335 5.42397 9.43918 5.42397 10.4475C5.42397 11.0433 5.15864 11.5658 4.7478 11.905C5.53524 12.8767 6.69072 13.5 7.99171 13.5C9.29269 13.5 10.4567 12.8767 11.2442 11.8958C10.8419 11.5567 10.5766 11.0342 10.5766 10.4475Z",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66871 4.7C9.69439 4.58083 9.70295 4.46167 9.70295 4.33333C9.70295 3.325 8.93262 2.5 7.99112 2.5C7.04962 2.5 6.2793 3.325 6.2793 4.33333C6.2793 4.46167 6.28786 4.58083 6.31353 4.7",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31348 4.70001C6.46754 5.54335 7.16083 6.16668 7.99106 6.16668C8.8213 6.16668 9.51459 5.53418 9.66865 4.70001",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71182 8.61407C2.77032 8.61407 2 9.43907 2 10.4474C2 11.4557 2.77032 12.2807 3.71182 12.2807C4.10554 12.2807 4.45647 12.1432 4.74748 11.9049",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7478 11.8958C5.15864 11.5566 5.42397 11.0341 5.42397 10.4383C5.42397 9.42992 4.66221 8.61409 3.7207 8.60492",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 11.8957C11.5352 12.1341 11.8946 12.2807 12.2884 12.2807C13.2299 12.2807 14.0002 11.4557 14.0002 10.4474C14.0002 9.43907 13.2299 8.61407 12.2884 8.61407",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.6023d76494d38f402ea29405b64f9442.svg";
export { ForwardRef as ReactComponent };